import { chainConfig, ethereumFacts } from '@morpho-org/viem-dlc/chains'
import { defineChain as viemDefineChain } from 'viem'
import { katana as viemKatana } from 'viem/chains'

import type { AppChain } from './chain.types'

export const katana = viemDefineChain({ ...viemKatana, ...chainConfig }).extend({
  viemDlc: ethereumFacts,
  custom: {
    name: 'Katana',
    shortName: 'Katana',
    safeShortName: 'katana',
    morphoChainSlug: 'katana',
    defiLlamaSlug: 'katana',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://www.katanascan.com', name: 'Katana Scan' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x4F708C0ae7deD3d74736594C2109C2E3c065B428',
          startBlock: 2741069n
        },
        MorphoBlue: { address: '0xD50F2DffFd62f94Ee4AEd9ca05C61d0753268aBc', startBlock: 2741069n },
        MetaMorphoV11Factory: {
          address: '0x1c8De6889acee12257899BFeAa2b7e534de32E16',
          startBlock: 2741420n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0xFcb8b57E56787bB29e130Fca67f3c5a1232975D1',
          startBlock: 13096629n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0x2e6BE3a3A27fb45c6AbA2D1833eeA48E8788538e',
          startBlock: 13096629n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x6d6A3ba62836d6B40277767dCAc8fd390d4BcedC',
          startBlock: 18619527n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xc8D22B1adD3D176600E9952e7876e9249254cAAF',
          startBlock: 13096629n
        },
        RegistryList: {
          address: '0xA9132a09838fD20304dF2B2892679d06A4cc6371',
          startBlock: 13096853n
        },
        BluePublicAllocator: {
          address: '0xd952175e940D97775cBC5a523977a6f091D0d702',
          startBlock: 40217302n
        }
      }
    }
  }
}) satisfies AppChain<{ v1: true; v2: true }>
